import { createTheme } from '@mui/material/styles';
import * as theme from '../theme';

const muiTheme = createTheme({
  palette: {
    primary: {
      main: theme.Colors.RHPurple, // Customize this
    },
    secondary: {
      main: theme.Colors.RHGray,
    },
    tertiary: {
      main: theme.Colors.RHBlack
    },
    off: {
      main: theme.Colors.RHPurpleLight
    },
    on: {
      main: theme.Colors.Purple
    },
    background: {
      default: theme.Colors.White,
    },
    text: {
      primary: theme.Colors.RHBlack,
    },
  },
});

export default muiTheme;